const ALLOWED_API_URLS = [
  "/api/v1/studymanagement/studies{/studyId}/welcomecontent" /* Onboarding add/edit api */,
  "/api/v2/studymanagement/studies{/studyId}/consentsections/add{/consentId}" /* eConsent - add education screen api */,
  "/api/v2/studymanagement/studies{/studyId}/consent/{consentId}/consentsections{/sectionId}" /* eConsent - edit education screen api */,
  "/api/v2/studymanagement/studies{/studyId}/consent/{consentId}/consentdocument" /* eConsent - add/edit consent document api */,
  "/api/v2/studymanagement/studies{/studyId}/consent/{consentId}/disclaimerUpdate" /* eConsent - add/edit additional disclaimer api */,
  "api/v2/studymanagement/studies{/studyId}/consentprivacy" /* eConsent - privacy policy api */,
  "/api/v1/studymanagement/studies{/studyId}/learnmore/sections" /* learn more add api */,
  "/api/v1/studymanagement/studies{/studyId}/learnmore/sections{/sectionId}" /* learn more edit api */,
  "/api/v1/surveymanagement/surveys{/surveyId}/questions" /* survey question add api */,
  "api/v1/surveymanagement/surveys{/surveyId}/questions{/questionId}" /* survey question edit api */,
  "/api/v2/surveymanagement/epros{/surveyId}/questions" /* epro question add api */,
  "/api/v2/surveymanagement/epros{/surveyId}/questions{/questionId}" /* epro question edit api */,
  "/api/v1/studymanagement/studies{/studyId}/appdescription" /* launch - app page description api */,
  "/api/v1/studymanagement/studies{/studyId}/sites{/siteId}/document{/documentId}/disclaimer" /* research site - document disclaimer add/edit api */,
  "/api/v1/studymanagement/studies{/studyId}/sites{/siteId}/document{/documentId}/configure" /* research site - configure document add/edit api */,
  "/api/v1/participant-web/studies{/studyId}/web/globalelements" /* participant web - global elements add/edit api */,
  "/api/v1/participant-web/studies{/studyId}/web/homepage" /** participant web - homepage add/edit api */,
  "/api/v1/participant-web/studies{/studyId}/web/eligibility" /** participant web - eligibility add/edit api */,
  "/api/v1/participant-web/studies{/studyId}/web/registration" /** participant web - registration add/edit api */,
  "/api/v1/activity/activities/{activityId}/questions" /** activity builder - save question */,
  "/api/v1/activity/activities/{activityId}/questions{/questionId}" /** activity builder - update existing question */
];

const javascriptStrings = ["&lt;script(.*?)&gt;(.*?)&lt;/script&gt;", "<script(.*?)>(.*?)</script>", "<script>(.*?)</script>", "</script>", "<script(.*?)>", "eval\\((.*?)\\)", "expression\\((.*?)\\)", "javascript:(.*?)", "vbscript:(.*?)", "onload(.*?)=", "<script (.*?)>(.*?)</script>", "javascript:", "vbscript:"];

const htmlEvents = [
  "eval\\\\((.*?)\\\\)",
  "expression\\\\((.*?)\\\\)",
  "onload(\\s*)=",
  "FSCommand(\\s*)=",
  "onAbort(\\s*)=",
  "onActivate(\\s*)=",
  "onAfterPrint(\\s*)=",
  "onAfterUpdate(\\s*)=",
  "onBeforeActivate(\\s*)=",
  "onBeforeCopy(\\s*)=",
  "onBeforeCut(\\s*)=",
  "onBeforeDeactivate(\\s*)=",
  "onBeforeEditFocus(\\s*)=",
  "onBeforePaste(\\s*)=",
  "onBeforePrint(\\s*)=",
  "onBeforeUnload(\\s*)=",
  "execCommand(\\s*)=",
  "onBeforeUpdate(\\s*)=",
  "onBegin(\\s*)=",
  "onBlur(\\s*)=",
  "onBounce(\\s*)=",
  "onCellChange(\\s*)=",
  "onChange(\\s*)=",
  "onClick(\\s*)=",
  "onControlSelect(\\s*)=",
  "onCopy(\\s*)=",
  "onCut(\\s*)=",
  "onDataAvailable(\\s*)=",
  "onDataSetChanged(\\s*)=",
  "onDataSetComplete(\\s*)=",
  "onDblClick(\\s*)=",
  "onDeactivate(\\s*)=",
  "onDrag(\\s*)=",
  "onDragEnd(\\s*)=",
  "onDragLeave(\\s*)=",
  "onDragEnter(\\s*)=",
  "onDragOver(\\s*)=",
  "onDragDrop(\\s*)=",
  "onDragStart(\\s*)=",
  "onDrop(\\s*)=",
  "onEnd(\\s*)=",
  "onError(\\s*)=",
  "onErrorUpdate(\\s*)=",
  "onFilterChange(\\s*)=",
  "onFinish(\\s*)=",
  "onFocus(\\s*)=",
  "onFocusIn(\\s*)=",
  "onFocusOut(\\s*)=",
  "onHashChange(\\s*)=",
  "onHelp(\\s*)=",
  "onInput(\\s*)=",
  "onKeyDown(\\s*)=",
  "onKeyPress(\\s*)=",
  "onKeyUp(\\s*)=",
  "onLayoutComplete(\\s*)=",
  "onLoseCapture(\\s*)=",
  "onMediaComplete(\\s*)=",
  "onMediaError(\\s*)=",
  "onMessage(\\s*)=",
  "onMouseDown(\\s*)=",
  "onMouseEnter(\\s*)=",
  "onMouseLeave(\\s*)=",
  "onMouseMove(\\s*)=",
  "onMouseOut(\\s*)=",
  "onMouseOver(\\s*)=",
  "onMouseUp(\\s*)=",
  "onMouseWheel(\\s*)=",
  "onMove(\\s*)=",
  "onMoveEnd(\\s*)=",
  "onMoveStart(\\s*)=",
  "onOffline(\\s*)=",
  "onOnline(\\s*)=",
  "onOutOfSync(\\s*)=",
  "onPaste(\\s*)=",
  "onPause(\\s*)=",
  "onPopState(\\s*)=",
  "onProgress(\\s*)=",
  "onPropertyChange(\\s*)=",
  "onReadyStateChange(\\s*)=",
  "onRedo(\\s*)=",
  "onRepeat(\\s*)=",
  "onReset(\\s*)=",
  "onResize(\\s*)=",
  "onResizeEnd(\\s*)=",
  "onResizeStart(\\s*)=",
  "onResume(\\s*)=",
  "onReverse(\\s*)=",
  "onRowsEnter(\\s*)=",
  "onRowExit(\\s*)=",
  "onRowDelete(\\s*)=",
  "onRowInserted(\\s*)=",
  "onScroll(\\s*)=",
  "onSeek(\\s*)=",
  "onSelect(\\s*)=",
  "onSelectionChange(\\s*)=",
  "onSelectStart(\\s*)=",
  "onStart(\\s*)=",
  "onStop(\\s*)=",
  "onStorage(\\s*)=",
  "onSyncRestored(\\s*)=",
  "onSubmit(\\s*)=",
  "onTimeError(\\s*)=",
  "onTrackChange(\\s*)=",
  "onUndo(\\s*)=",
  "onUnload(\\s*)=",
  "onURLFlip(\\s*)=",
  "seekSegmentTime(\\s*)=",
  "offline(\\s*)=",
  "online(\\s*)=",
  "onPageHide(\\s*)=",
  "onPageShow(\\s*)=",
  "onContextMenu(\\s*)=",
  "onInvalid(\\s*)=",
  "onSearch(\\s*)=",
  "onWheel(\\s*)=",
  "onCanPlay(\\s*)=",
  "onCanPlayThrough(\\s*)=",
  "onCueChange(\\s*)=",
  "onDurationChange(\\s*)=",
  "onEmptied(\\s*)=",
  "onEnded(\\s*)=",
  "onLoadeddata(\\s*)=",
  "onLoadedmetadata(\\s*)=",
  "onLoadstart(\\s*)=",
  "onPlay(\\s*)=",
  "onPlaying(\\s*)=",
  "onRateChange(\\s*)=",
  "onSeeked(\\s*)=",
  "onSeeking(\\s*)=",
  "onStalled(\\s*)=",
  "onSuspend(\\s*)=",
  "onTimeUpdate(\\s*)=",
  "onVolumeChange(\\s*)=",
  "onWaiting(\\s*)=",
  "onToggle(\\s*)=",
  "onBeforeonload(\\s*)=",
  "onFormChange(\\s*)=",
  "onFormInput(\\s*)=",
  "onHasChange(\\s*)=",
  "onBeforeInput(\\s*)=",
  "onBeforeInputCapture(\\s*)=",
  "onAfterScriptExecute(\\s*)=",
  "onAnimationCancel(\\s*)=",
  "onAnimationEnd(\\s*)=",
  "onAnimationIteration(\\s*)=",
  "onAnimationStart(\\s*)=",
  "onAuxClick(\\s*)=",
  "onBeforeScriptExecute(\\s*)=",
  "onClose(\\s*)=",
  "onFullScreenChange(\\s*)=",
  "onloadEnd(\\s*)=",
  "onMozFullScreenChange(\\s*)=",
  "onPointerDown(\\s*)=",
  "onPointerEnter(\\s*)=",
  "onPointerLeave(\\s*)=",
  "onPointerMove(\\s*)=",
  "onPointerOut(\\s*)=",
  "onPointerOver(\\s*)=",
  "onPointerRawUpdate(\\s*)=",
  "onPointerUp(\\s*)=",
  "onShow(\\s*)=",
  "onTouchEnd(\\s*)=",
  "onTouchMove(\\s*)=",
  "onTouchStart(\\s*)=",
  "onTransitionCancel(\\s*)=",
  "onTransitionEnd(\\s*)=",
  "onTransitionRun(\\s*)=",
  "onTransitionStart(\\s*)=",
  "onUnhandledRejection(\\s*)=",
  "onWebkitAnimationEnd(\\s*)=",
  "onWebkitAnimationIteration(\\s*)=",
  "onWebkitAnimationStart(\\s*)=",
  "onWebkitTransitionEnd(\\s*)="
];

export default class XssFilterUtility {
  cleanRequestData(request) {
    if (!this.isApiAllowedToApplyFilter(request)) {
      return request;
    }

    if (request.body && typeof request.body === "object") {
      // cleaning Request Body

      request.body = this.cleanRequestBodyData(request);
    }
    if (request.headers && typeof request.headers === "object") {
      // cleaning Request Headers

      request.headers = this.cleanRequestHeaderData(request);
    }
    request.url = this.cleanRequestUrlData(request); // cleaning Request Query Params in the URL

    return request;
  }

  isApiAllowedToApplyFilter(request) {
    if (request && request.url) {
      for (let api of ALLOWED_API_URLS) {
        if (request.url.includes(api)) {
          return true;
        }
      }
      return false;
    }
  }

  cleanRequestBodyData(request) {
    if (request && request.body && typeof request.body === "object" && (request.method === "PUT" || request.method === "POST")) {
      return this.cleanBodyData(request.body);
    }
  }

  cleanBodyData(body) {
    if (Object.prototype.toString.call(body) === "[object FormData]") {
      // if request has FormData
      for (let pair of body.entries()) {
        if (typeof pair[1] === "string") {
          body.set(pair[0], this.stripeHarmfulScripts(pair[1]));
        } else if (Object.prototype.toString.call(pair[1]) === "object") {
          body.set(pair[0], this.cleanBodyData(pair[1]));
        }
      }
    } else if (Object.prototype.toString.call(body) === "[object Object]") {
      // if request has user-defined Object
      for (let prop in body) {
        if (typeof body[prop] === "string") {
          body[prop] = this.stripeHarmfulScripts(body[prop]);
        } else if (Object.prototype.toString.call(body[prop]) === "object") {
          body[prop] = this.cleanBodyData(body[prop]);
        }
      }
    } else if (Object.prototype.toString.call(body) === "[object Array]") {
      // if request has Array
      for (let element of body) {
        if (typeof element === "string") {
          body[element] = this.stripeHarmfulScripts(element);
        } else if (typeof element == "object") {
          Object.entries(element).forEach(prop => {
            if (typeof element[prop] === "string") {
              body[element][prop] = this.stripeHarmfulScripts(element[prop]);
            } else if (Object.prototype.toString.call(element[prop]) === "object") {
              body[element][prop] = this.cleanBodyData(element[prop]);
            }
          });
        }
      }
    }
    return body;
  }

  cleanRequestHeaderData(request) {
    if (request && request.headers && (request.method === "PUT" || request.method === "POST")) {
      for (let prop in request.headers) {
        if (Object.prototype.toString.call(request.headers[prop]) === "[object Object]") {
          for (let innerProp in request.headers[prop]) {
            if (typeof request.headers[prop][innerProp] === "string") {
              // if header value is a string

              request.headers[prop][innerProp] = this.stripeHarmfulScripts(request.headers[prop][innerProp]);
            } else if (Object.prototype.toString.call(request.headers[prop][innerProp]) === "[object Array]") {
              // if header value is an Array
              for (let index in request.headers[prop][innerProp]) {
                if (typeof request.headers[prop][innerProp][index] === "string") {
                  request.headers[prop][innerProp][index] = this.stripeHarmfulScripts(request.headers[prop][innerProp][index]);
                }
              }
            }
          }
        }
      }
      return request.headers;
    }
  }

  cleanRequestUrlData(request) {
    if (request.url && request.url.indexOf("?") > -1) {
      request.url = this.stripeHarmfulScripts(request.url);
    }
    return request.url;
  }

  stripeHarmfulScripts(text) {
    let filteredText = text;

    if (!text) {
      return text;
    }

    filteredText = text.replaceAll(new RegExp("&amp;", "g"), "&");

    javascriptStrings.forEach(item => (filteredText = filteredText.replaceAll(new RegExp("" + item + "", "g"), "")));
    htmlEvents.forEach(item => (filteredText = filteredText.replaceAll(new RegExp("" + item + "", "g"), "")));
    htmlEvents.forEach(item => (filteredText = filteredText.replaceAll(new RegExp("" + item.toLowerCase() + "", "g"), "")));
    htmlEvents.forEach(item => (filteredText = filteredText.replaceAll(new RegExp("" + item.toUpperCase() + "", "g"), "")));
    return filteredText;
  }
}
